<!--
 * @Author: Sephiroth·D·Kid
 * @Date: 2019-06-27 16:19:44
 * @LastEditors: yuka
 * @LastEditTime: 2019-08-09 10:59:54
 * @Description: 审核信息
 -->

<template>
  <div class="m-check-info-wrapper">
    <router-view></router-view>
  </div>
</template>
<script>
export default {
  name: 'check-info',
  computed: {
    showRouterView() {
      return window.location.href.findIndex('check-info');
    }
  }
};
</script>
<style lang="less" scope>
.m-check-info-wrapper {
  box-sizing: border-box;
  .link-item {
    display: flex;
    justify-content: space-between;
    font-size: 0.28rem;
    align-items: center;
    height: 1rem;
  }
  img {
    width: 100%;
  }
}
</style>
